import md5 from 'js-md5'

function genParamsString(params) {
  const result = __genSaltSign(params)
  let arr = []
  Object.keys(result).forEach(key => {
    arr.push(`${key}=${result[key]}`)
  })
  return arr.join('&')
}
const appId = 'bcca825d-f5d7-4359-8704-116c75f74f64'
const salt = 'WdAwuUooLajE2QRy'
function __genSaltSign(params) {
  let obj: any = {}
  if (typeof params == 'object') obj = Object.assign({}, params)
  if (typeof params == 'string') {
    params = params.replace('?', '')
    params.split('&').forEach(item => {
      item = item.split('=')
      obj[item[0]] = item[1]
    })
  }
  obj.appId = appId
  obj.v_ts = +new Date()
  const keys = Object.keys(obj).sort()
  let signStr = keys.reduce((p, a) => {
    return `${p}${a}${obj[a]}`
  }, '')
  signStr = signStr.slice(0, 6) + salt + signStr.slice(6)
  return {
    ...obj,
    sign: md5(signStr)
  }
}
export function __getAudioUrl({
  type,
  speaker,
  speakerSource,
  speed,
  txt,
  articleId,
  pauseMap,
  wwid,
  ww_token
}) {
  let frontendType = 'man'
  const url = '/tts/ssml'
  let params = `audio_type=${type}&speaker=${speaker}&speaker_source=${speakerSource}&frontend_type=${frontendType}&speed=${speed}&text=${txt}&pause_map=${pauseMap}&wwid=${wwid}&ww_token=${ww_token}`
  // 获取文章id
  params += `&article_id=${articleId}`

  params += '&cmu_check=true'
  return url + '?' + genParamsString(params)
}
